













import { defineComponent } from '@vue/composition-api';

import CommonFormWithCashFlowEditor from '@/components/CashFlow/CommonFormWithCashFlowEditor.vue';
import CommonDropzoneWithCashFlowUpload from '@/components/CashFlow/CommonDropzoneWithCashFlowUpload.vue';

const CreateExpense = defineComponent({
  components: {
    CommonFormWithCashFlowEditor,
    CommonDropzoneWithCashFlowUpload,
  },
});

export default CreateExpense;
